module.exports = __webpack_public_path__ + "600e3adebfe15b4680a1e85d35210b19.mp4";